<template>
  <div class="seating">
    <div class="container">
      <router-link :to="{ name: 'home', params: $route.params }">
        <button class="back_btn">Back</button></router-link
      >
      <div class="gallery">
        <img
          src="~images/grandstands/img-grandstands-top.jpg"
          class="slide_image"
        />
      </div>
      <h1 class="title">Grandstands</h1>

      <div class="extra">
        <Card v-for="box in boxes" :key="box.id" :box="box" />
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted } from "@vue/runtime-core";
import { useRoute } from "vue-router";
import router from "@/router";
import Card from "@/components/Card.vue";

export default {
  components: { Card },
  setup() {
    const route = useRoute();
    const boxes = [
      {
        id: 0,
        imgSrc: "start-finish.jpg",
        title: "START / FINISH GRANDSTAND",
        desc: "With premium views of the Paddock, starting grid, and main straight, the Start / Finish Grandstand puts you right at the center of the action. There will also be access to culinary activations positioned directly behind the structure, in the North Campus zones.",
      },
      {
        id: 1,
        imgSrc: "turn18.jpg",
        title: "TURN 18 GRANDSTAND",
        desc: "Turn 18 Grandstand is the circuit’s most premier grandstand with superior vantage points of dynamic racing. Positioned along Turn 18, the location of the grandstand allows one to watch the drivers attempt to out-brake one another coming off the 2nd fastest straightaway in Formula 1 and onto one of the best passing zones on the track. Formula 1 Fan Zones and West Campus pop-up activations are conveniently located near Turn 18.  ",
      },
      {
        id: 2,
        imgSrc: "northbeach.jpg",
        title: "NORTH BEACH GRANDSTAND",
        desc: "Where South Beach meets Formula 1, and the party does not stop. Positioned around Turns 11, 12 and 13, this section of the track offers you superior views of competitive racing and is located near Beach House activations.  ",
      },
      {
        id: 3,
        imgSrc: "south-beach.jpg",
        title: "SOUTH BEACH GRANDSTAND",
        desc: "Where South Beach meets Formula 1, and the party does not stop. Positioned around Turns 11, 12 and 13, this section of the track offers you superior views of competitive racing and is located near Beach House activations.  ",
      },
      {
        id: 4,
        imgSrc: "turn1north.jpg",
        title: "TURN 1 NORTH GRANDSTAND",
        desc: "Positioned with vantage points of the Start / Finish straight, you will witness the action of the world’s fastest machines, with potential overtaking zones, headed straight into Turn 1 of the circuit. The location of Turn 1 North Grandstand is near North Campus’ food and beverage activations. ",
      },
      {
        id: 5,
        imgSrc: "turn1east.jpg",
        title: "TURN 1 EAST GRANDSTAND",
        desc: "Positioned with vantage points of the Start / Finish straight, you will witness the action of the world’s fastest machines, with potential overtaking zones, headed straight into Turn 1 of the circuit. The location of Turn 1 East Grandstand is near North Campus’ food and beverage activations. ",
      },
      {
        id: 6,
        imgSrc: "family.jpg",
        title: "FAMILY GRANDSTAND",
        desc: "Positioned with views of Turn 10, and is located near fan zones, activations and F1 experiences, the Family Grandstand is perfect for the whole family.  ",
      },
      {
        id: 8,
        imgSrc: "marina.jpg",
        title: "Marina Grandstands",
        desc: "What says Miami more than a yacht club and marina? Positioned along the highspeed cornering complex of corner 7, you will take in the action of high-speed racing from your seats. You will also have access to general admission areas of the Marina for a bevy of food and beverage options. ",
      },
    ];
    // {
    //     id: 10,
    //     imgSrc: "the-fountain.jpg",
    //     title: "THE FOUNTAIN VIEW GRANDSTAND",
    //     desc: "Positioned at the entrance of Turn 9, The Fountain View Grandstand offers convenient access to activations in the Grove and Fountain areas. The location of The Fountain View Grandstand also allows for sweeping views of the track action in addition to a prominent view of the South Campus video screen.  ",
    //   },
    onMounted(() => {
      window.scrollTo(0, 0);
      const params = route.params;
    });
    return { router, boxes };
  },
};
</script>

<style lang="scss" scoped>
.seating {
  position: inherit;
  .gallery {
    img {
      border-radius: 0 0 10px 10px;
      box-shadow: 0 2px 24px 0 rgba(0, 0, 0, 0.17);
      max-width: 100%;
    }
  }
  .title {
    font-family: Garland;
    font-size: 84px;
    color: #008e97;
    text-align: center;
    font-weight: 400;
    position: relative;
    padding: 50px 0 40px;
    margin-bottom: 50px;
    &::after {
      background-image: url("~images/pluses-green.svg");
      content: "";
      display: block;
      min-height: 0.1em;
      overflow: hidden;
      bottom: 0px;
      position: absolute;
      width: 50%;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  .back_btn {
    background-image: linear-gradient(0deg, #efefef 0%, #fdfdfd 100%);
    border: none;
    box-shadow: 0 2px 24px 0 rgba(0, 0, 0, 0.33);
    border-radius: 0 0 20px 20px;
    font-family: Formula1-Display-Bold;
    font-size: 13px;
    color: #000000;
    text-align: center;
    font-weight: 500;
    text-transform: uppercase;
    width: 211px;
    height: 45px;
    position: fixed;
    z-index: 2;
    left: 50%;
    transform: translateX(-50%);
  }
  .extra {
    display: flex;
    column-gap: 20px;
    padding-block: 40px;
    flex-wrap: wrap;
    justify-content: center;
  }
}
</style>